import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { MediaBreakPointUp, Sizes } from '@lean-body/components/styles';
import { ZIndex } from '../constants';
import { Toast } from './toast';
export const ToastStack = ({ toasts, onClose }) => {
    if (toasts.length === 0)
        return null;
    return (React.createElement("div", { className: css(styles.stack) }, toasts.map((toast) => (React.createElement(Toast, { key: toast.id, message: toast.message, onClose: () => onClose(toast.id) })))));
};
const styles = StyleSheet.create({
    stack: {
        position: 'fixed',
        width: 'calc(100% - 20px)',
        top: `calc(${Sizes.MobileHeaderHeight}px + 10px)`,
        right: 0,
        margin: '0 10px',
        zIndex: ZIndex.Toast,
        [MediaBreakPointUp.MD]: {
            width: 375,
            right: 22,
            top: 100,
        },
    },
});
